import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid, tenantId) {
    const data = {
        username,
        password,
        code,
        uuid,
        tenantId
    }
    return request({
        url: '/login',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}

export function fastLogin(username, password, code, uuid) {
    return request({
        url: '/fastLogin',
        headers: {
            isToken: false
        },
        method: 'post',
        data: {username, password, code, uuid}
    })
}

// 注册方法
export function register(data) {
    return request({
        url: '/register',
        headers: {
            isToken: false
        },
        method: 'post',
        data: data
    })
}

// 获取用户详细信息
export function getInfo() {
    return request({
        url: '/getInfo',
        method: 'get'
    })
}

// 退出方法
export function logout() {
    return request({
        url: '/logout',
        method: 'post'
    })
}

// 获取验证码
export function getCodeImg() {
    return request({
        url: '/captchaImage',
        headers: {
            isToken: false
        },
        method: 'get',
        timeout: 20000
    })
}